type NavigationGuard = (destination: string) => boolean;

let activeGuard: NavigationGuard | null = null;

export function registerPracticeNavigationGuard(guard: NavigationGuard | null) {
  activeGuard = guard;
}

/** Returns true if navigation should proceed. */
export function tryPracticeNavigation(destination: string): boolean {
  if (!activeGuard) return true;
  return activeGuard(destination);
}

export function hasPracticeNavigationGuard(): boolean {
  return activeGuard !== null;
}
